export interface AdminRuntimeConfig {
  chat_generation_url: string;
  media_generation_url: string;
  media_location_url: string;
}

export const DEFAULT_ADMIN_RUNTIME_CONFIG: AdminRuntimeConfig = {
  chat_generation_url: 'https://api.lightspeedcloud.ai/api/v1/ollama/chat',
  media_generation_url: 'https://api.lightspeedcloud.ai/api/v1',
  media_location_url: import.meta.env.VITE_SUPABASE_URL,
};

export function normalizeAdminRuntimeConfig(
  value: Partial<AdminRuntimeConfig> | null | undefined
): AdminRuntimeConfig {
  return {
    chat_generation_url: value?.chat_generation_url?.trim() || DEFAULT_ADMIN_RUNTIME_CONFIG.chat_generation_url,
    media_generation_url: value?.media_generation_url?.trim() || DEFAULT_ADMIN_RUNTIME_CONFIG.media_generation_url,
    media_location_url: value?.media_location_url?.trim() || DEFAULT_ADMIN_RUNTIME_CONFIG.media_location_url,
  };
}

export function resolveMediaLocationUrl(
  mediaUrl: string | null | undefined,
  mediaLocationUrl: string
): string | null {
  if (!mediaUrl) {
    return null;
  }

  if (/^https?:\/\//i.test(mediaUrl)) {
    return mediaUrl;
  }

  try {
    return new URL(mediaUrl, mediaLocationUrl.endsWith('/') ? mediaLocationUrl : `${mediaLocationUrl}/`).toString();
  } catch {
    return mediaUrl;
  }
}
